import {
  IOTV_SNSAttributeMapToMap,
  IOTV_SNSEvent,
  IOTV_SNSPublishInputToMessageAttributeMap,
  IOTV_SNS_MapLike,
  IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap,
  IOTV_SNS_ReceiveMessageAttribute,
  MapLike,
} from '@iotv/iotv-v3-types'

export type MockSNSEventParams = {
  topicArn?: string
  subject?: string
  messageAttributesObject?: IOTV_SNS_MapLike
}

export type GetSNSEventParams<T> = { payload: T; eventParams: Partial<MockSNSEventParams> }

export const getSNSEvent = <T extends MapLike<any>>({ payload, eventParams }: GetSNSEventParams<T>) => {
  const messageAttributes = eventParams.messageAttributesObject ?? {}
  const template = {
    Records: [
      {
        EventSource: 'aws:sns',
        EventVersion: '1.0',
        EventSubscriptionArn: 'bbb',
        Sns: {
          Type: 'Notification',
          MessageId: 'aaa',
          TopicArn: eventParams.topicArn ?? 'arn:aws:sns:mockRegion:mockAccountId:mockTopic',
          Subject: eventParams.subject ?? 'mockSubject',
          Message: '',
          Timestamp: '',
          SignatureVersion: '1',
          Signature: '',
          SigningCertURL: '',
          UnsubscribeURL: '',
          MessageAttributes: eventParams.messageAttributesObject
            ? IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap(messageAttributes)
            : {
                sk: {
                  Type: 'String',
                  Value: 'Something:ABC123_latestShadowState',
                },
                eventName: {
                  Type: 'String',
                  Value: 'MODIFY',
                },
                pk: {
                  Type: 'String',
                  Value: 'Something:ABC123',
                },
                type: {
                  Type: 'String',
                  Value: 'ThingShadowState',
                },
              },
        },
      },
    ],
  }

  template.Records[0].Sns.Message = JSON.stringify(payload)

  return template as unknown as IOTV_SNSEvent<T>
}
